__turbopack_context__.v({
  "block": "_BlockCS-module-scss-module__IVrvsW__block",
  "blockAboveTheFold": "_BlockCS-module-scss-module__IVrvsW__blockAboveTheFold",
  "blocksBackgroundColor": "_BlockCS-module-scss-module__IVrvsW__blocksBackgroundColor",
  "blocksFontColor": "_BlockCS-module-scss-module__IVrvsW__blocksFontColor",
  "secondaryNavBackgroundColor": "_BlockCS-module-scss-module__IVrvsW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "_BlockCS-module-scss-module__IVrvsW__themeBackgroundColor",
  "themeFontColor": "_BlockCS-module-scss-module__IVrvsW__themeFontColor",
});
